import { createFileRoute } from "@tanstack/react-router";
import { aboutRoute, AboutPage } from "@/features/company-story";

export const Route = createFileRoute("/about")({
    loader: aboutRoute.loader,
    head: aboutRoute.head,
    component: AboutPage,
});
